import Tile from "@amzn/meridian/esm/components/tile";
import Box from "@amzn/meridian/esm/components/box";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Button from "@amzn/meridian/esm/components/button";
import Icon from "@amzn/meridian/esm/components/icon";
import closeSmallTokens from "@amzn/meridian-tokens/base/icon/close-small";
import { THEME_COLOR } from "../../../../styles/colors";

const SEVERITY_ICON = {
  info: "ℹ️",
  warning: "⚠️",
  critical: "🛑",
};

// Dismissal is owned by the caller, not local state: it has to survive a tab switch
// (which unmounts the assistant tree), and the surrounding message needs to know the
// card is gone so it can drop the agent avatar when nothing is left.
const AlertBanner = ({ message, severity, dismissible, onDismiss }) => {
  const icon = SEVERITY_ICON[severity] || SEVERITY_ICON.info;

  return (
    <Tile accent={THEME_COLOR.MID_GRAY} spacingInset="none">
      <Box spacingInset="400">
        <Row alignmentVertical="center" widths={["fill", "fit"]}>
          <Row spacing="300" alignmentVertical="center">
            <Text type="b200">{icon}</Text>
            <Text type="b200">{message}</Text>
          </Row>
          {dismissible && onDismiss && (
            <Button type="icon" size="small" onClick={onDismiss}>
              <Icon tokens={closeSmallTokens}>Dismiss</Icon>
            </Button>
          )}
        </Row>
      </Box>
    </Tile>
  );
};

export default AlertBanner;
